export default __webpack_public_path__ + "static/media/asmt-step4.38443f28.gif";